/**
 * @generated SignedSource<<397ef48eb71cf90a7683f002c608a148>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ratesAndInternalCostPage_company$data = {
  readonly id: string;
  readonly currency: string | null;
  readonly roles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly dateEffectiveExchangeRates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly currency: string | null;
        readonly rate: number | null;
        readonly startDate: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly rateCards: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly defaultRate: number | null;
        readonly currency: string | null;
        readonly parentRateCardId: string | null;
        readonly rates: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly rate: number | null;
              readonly defaultRate: boolean | null;
              readonly startDate: string | null;
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"RateCardDropdown_rateCards">;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ratesAndInternalCostPage_company";
};
export type ratesAndInternalCostPage_company$key = {
  readonly " $data"?: ratesAndInternalCostPage_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ratesAndInternalCostPage_company">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ratesAndInternalCostPage_company",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "RoleTypeConnection",
      "kind": "LinkedField",
      "name": "roles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roles(first:10000)"
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "ExchangeRateTypeConnection",
      "kind": "LinkedField",
      "name": "dateEffectiveExchangeRates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ExchangeRateTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExchangeRate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "dateEffectiveExchangeRates(first:10000)"
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "RateCardTypeConnection",
      "kind": "LinkedField",
      "name": "rateCards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCardTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RateCardDropdown_rateCards"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RateCard",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v3/*: any*/),
                (v7/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "parentRateCardId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v2/*: any*/),
                  "concreteType": "RateTypeConnection",
                  "kind": "LinkedField",
                  "name": "rates",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RateTypeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Rate",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v5/*: any*/),
                            (v7/*: any*/),
                            (v6/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Role",
                              "kind": "LinkedField",
                              "name": "role",
                              "plural": false,
                              "selections": (v4/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "rates(first:10000)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "rateCards(first:10000)"
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "80b92308fdcb6b529dcfda1185883639";

export default node;
